<button mat-icon-button [matMenuTriggerFor]="filterMenu">
  <span>
    @if (selectedOperator || (selectedItems.length > 0)) {
      <mat-icon>filter_list</mat-icon>
    }
    @if (selectedSort==='desc') {
      <mat-icon>arrow_upward</mat-icon>
    }
    @if (selectedSort==='asc') {
      <mat-icon>arrow_downward</mat-icon>
    }
    <mat-icon>arrow_drop_down</mat-icon>
  </span>
</button>

<mat-menu #filterMenu="matMenu" xPosition="before" class="menu-overflow-hidden tf-mat-menu">
  <div class="container content-centered" (click) = "$event.stopPropagation()">
    <form>
      <div class="row">
        <div class="col-8" style="padding-left: 0px; padding-right: 16px; display: flex">
          <button class="float-start;" mat-button (click)="onSortAsc()">Sort Ascending</button>
        </div>
        <div class="col-4 ml-auto">
          <button class="float-right" style="min-width: 0px" mat-flat-button color="primary"  (click)="onValidation()">
            OK
          </button>
        </div>
      </div>
      <div class="row">
          <div class="col-12"  style="padding-left: 0px">
            <button class="float-start" mat-button (click)="onSortDesc()">Sort Descending</button>
          </div>
      </div>
      @if (selectedSort) {
        <div class="row">
          <div class="col-12"  style="padding-left: 0px">
            <button  class="float-start" mat-button  (click)="onSortClear()">Clear Sort</button>
          </div>
        </div>
      }

      <div class="row">
        <div class="dropdown-divider"></div>
        <mat-form-field class="col-12">
          <mat-select placeholder="Select comparison" [(value)]="selectedOperator">
            @for (operator of operatorList; track operator.name) {
              <mat-option [value]="operator">
                {{operator.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (selectedOperator) {
        <div class="row">
          <mat-form-field class="col-12" (click) = "$event.stopPropagation()" >
            <input matInput placeholder="Numeric operand 1" [(ngModel)]="operand1Input" name="operand1Input">
          </mat-form-field>
        </div>
        @if (selectedOperator.operands === 3) {
          <div class="row">
            <span class="col-12">and</span>
          </div>
          <div class="row">
            <mat-form-field class="col-12" (click) = "$event.stopPropagation()" >
              <input matInput placeholder="Numeric operand 2" [(ngModel)]="operand2Input" name="operand2Input">
            </mat-form-field>
          </div>
        }
        <div class="row">
          <div class="col-12"  style="padding-left: 0px">
            <button class="float-start" mat-button  (click)="onClearFilter()">Clear Filter</button>
          </div>
        </div>
        <div class="dropdown-divider"></div>
      }

      @if (selectedItems.length) {
        <div>
          <div class="row">
            <div class="col-12"  style="padding-left: 0px">
              <button class="float-start" mat-button  (click)="onClearSelection()">Clear Selection</button>
            </div>
          </div>
        </div>
      }

      <div>
        <ng-multiselect-dropdown name="multi"  class="col-12"
          [class]="'filter-dropdown'"
          [settings]="dropdownSettings"
          [data]="choices"
          [placeholder]="'Select Items'"
          [(ngModel)]="selectedItems"
          >
        </ng-multiselect-dropdown>
      </div>
    </form>
  </div>
</mat-menu>
